import { _types } from "../types";
const { REQ,   
  BID_ADD_CART,
  BID_CART_ITEMS,
  BID_CHECKOUT,
  BID_CHECKOUT_COMPLETE,
  MY_BIDS,
  MY_BIDS_BY_TYPE,
  MY_BIDS_RECEIPT } = _types;
const actions = {
  myBids: (data) =>
    ({
      type: MY_BIDS + REQ,
      payload: data,
    }),
    myBidsBySelectedType: (data) =>
    ({
      type: MY_BIDS_BY_TYPE + REQ,
      payload: data,
    }),
  addToCart:(data) =>
    ({
      type: BID_ADD_CART + REQ,
      payload: data,
    }),
  cartItem:(data) =>
    ({
      type: BID_CART_ITEMS + REQ,
      payload: data,
    }),
  checkout:(data) =>
    ({
      type: BID_CHECKOUT + REQ,
      payload: data,
    }),
  checkout_Complete:(data) =>
    ({
      type: BID_CHECKOUT_COMPLETE + REQ,
      payload: data,
    }),
  downloadReceipt:(data) =>
  ({
    type: MY_BIDS_RECEIPT + REQ,
    payload: data,
  })
};
export default actions;
